/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { AppConsts } from '@lib';
import { GetCurrentLoginInformations, SessionService } from '@services';
import { makeAutoObservable, runInAction } from 'mobx';
import { StreamChat } from 'stream-chat';

class SessionStore {
  currentLogin: GetCurrentLoginInformations = new GetCurrentLoginInformations();
  chatClient: StreamChat | null = null;
  unreadCount: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  async getCurrentLoginInformations() {
    const result = await SessionService.getCurrentLoginInformations();
    this.currentLogin = result;
  }

  async connectChatUser() {
    const token = this.currentLogin?.user?.streamToken;
    const tenancyName = this.currentLogin?.tenant?.tenancyName;
    const tenantId = this.currentLogin?.tenant?.id;

    if (!token || !tenancyName || !tenantId) return;

    const chatTenantId = tenancyName + tenantId;

    const client = StreamChat.getInstance(AppConsts.streamApiKey, {
      enableInsights: true,
      enableWSFallback: true,
    });

    // Disconnect existing connection before reconnecting
    if (client.userID && client.userID !== chatTenantId) {
      await client.disconnectUser();
    }

    // Skip if already connected as the same user
    if (client.userID === chatTenantId) {
      runInAction(() => {
        this.chatClient = client;
        this.unreadCount = (client.user as any)?.unread_channels || 0;
      });
      return;
    }

    await client.connectUser(
      { id: chatTenantId, name: this.currentLogin?.tenant?.name || '' },
      token
    );

    runInAction(() => {
      this.chatClient = client;
      this.unreadCount = (client.user as any)?.unread_channels || 0;
    });
  }

  unreadCountChange = (count: number) => (this.unreadCount = count);

  disconnectChatUser = () => this.chatClient?.disconnectUser();
}

export default SessionStore;
